export const marketingPages = [
  {
    kind: "service",
    path: "/ki-agenten-fuer-unternehmen",
    title: "KI-Agenten für Unternehmen | ScandicDev",
    description:
      "KI-Agenten für Unternehmen: ScandicDev automatisiert Telefon, E-Mail, Dokumente und Workflows DSGVO-konform für den deutschen Mittelstand.",
    h1: "KI-Agenten für Unternehmen",
    intro:
      "Wir entwickeln KI-Agenten, die wiederkehrende Aufgaben entlang Ihrer realen Prozesse übernehmen: Telefon, E-Mail, Dokumente und interne Workflows. Der Fokus liegt auf pragmatischer Umsetzung, klaren Verantwortlichkeiten und DSGVO-konformer Prozessautomatisierung.",
    benefits: [
      "Entlastung von Teams bei wiederkehrenden Anfragen und Vorgängen",
      "Schnellere Reaktionszeiten über Telefon, E-Mail und Formulare",
      "Saubere Übergaben in bestehende CRM-, ERP- und Ticketsysteme",
      "Transparente Regeln für Freigaben, Eskalationen und menschliche Kontrolle",
    ],
    useCases: [
      {
        title: "Service- und Vertriebsanfragen vorsortieren",
        description: "Anliegen erkennen, priorisieren und an den richtigen Prozess oder Ansprechpartner weiterleiten.",
      },
      {
        title: "Dokumente und Eingänge strukturieren",
        description: "Relevante Informationen aus PDFs, Formularen und Anhängen extrahieren und in Folgeprozesse übergeben.",
      },
      {
        title: "Standardkommunikation ausführen",
        description: "Antwortentwürfe, Statusmeldungen, Terminbestätigungen und Nachfassprozesse zuverlässig automatisieren.",
      },
    ],
    implementation: [
      "Analyse der Abläufe mit Blick auf Nutzen, Risiken und Datenflüsse",
      "Technische Integration in vorhandene Systeme statt paralleler Schattenprozesse",
      "Betrieb mit klarer Governance für Datenschutz, Logging und Qualitätssicherung",
    ],
    ctaTitle: "KI-Agenten mit messbarem Prozessnutzen starten",
    ctaText:
      "Wir priorisieren gemeinsam die Prozesse mit dem größten Hebel und skizzieren einen realistischen ersten Go-Live.",
    relatedPaths: [
      "/ki-telefonassistent",
      "/ki-email-automation",
      "/ki-dokumentenverarbeitung",
    ],
  },
  {
    kind: "service",
    path: "/ki-telefonassistent",
    title: "KI-Telefonassistent für Unternehmen | ScandicDev",
    description:
      "KI-Telefonassistent für Unternehmen: Anrufe annehmen, Anliegen qualifizieren, Termine koordinieren und Vorgänge strukturiert weitergeben.",
    h1: "KI-Telefonassistent für Unternehmen",
    intro:
      "Ein KI-Telefonassistent entlastet Teams bei wiederkehrenden Anrufen, Rückrufbitten und Standardanliegen. So bleiben Erreichbarkeit und Servicequalität stabil, ohne dass das Tagesgeschäft ständig unterbrochen wird.",
    benefits: [
      "Anrufe außerhalb von Spitzenzeiten und Öffnungszeiten strukturiert abfangen",
      "Anliegen automatisch qualifizieren und korrekt an Teams oder Systeme übergeben",
      "Termin- und Rückrufprozesse mit klaren Regeln unterstützen",
      "Mehr Ruhe für Mitarbeitende bei gleichzeitig besserer Erreichbarkeit",
    ],
    useCases: [
      {
        title: "Rückrufe und Terminwünsche aufnehmen",
        description: "Rückrufgründe dokumentieren, Prioritäten erfassen und passende Slots vorbereiten.",
      },
      {
        title: "Einfache Servicefragen beantworten",
        description: "Standardinformationen bereitstellen und bei Bedarf sauber an Menschen eskalieren.",
      },
      {
        title: "Vorgänge im CRM oder Helpdesk anlegen",
        description: "Gesprächsergebnisse direkt in bestehende Systeme überführen, statt manuell nachzupflegen.",
      },
    ],
    implementation: [
      "Definition zulässiger Dialoge, Eskalationen und Freigaben",
      "Anbindung an Telefonie, Kalender und nachgelagerte Systeme",
      "Laufende Qualitätskontrolle anhand echter Gesprächsmuster",
    ],
    ctaTitle: "Telefonprozesse ohne Callcenter-Overhead verbessern",
    ctaText:
      "Wir prüfen, welche Anrufarten sinnvoll automatisiert werden können und wo menschliche Übergaben notwendig bleiben.",
    relatedPaths: [
      "/ki-agenten-fuer-unternehmen",
      "/ki-email-automation",
      "/branchen/arztpraxis",
    ],
  },
  {
    kind: "service",
    path: "/ki-email-automation",
    title: "KI-E-Mail-Automation für Unternehmen | ScandicDev",
    description:
      "KI-E-Mail-Automation für Unternehmen: Eingänge priorisieren, Antworten vorbereiten und Follow-ups DSGVO-konform in bestehende Workflows einbetten.",
    h1: "KI-E-Mail-Automation für Unternehmen",
    intro:
      "E-Mail bleibt in vielen Unternehmen der operative Flaschenhals. Mit KI-E-Mail-Automation lassen sich Postfächer strukturieren, Standardantworten vorbereiten und Folgeprozesse zuverlässig anstoßen, ohne Qualität oder Nachvollziehbarkeit zu verlieren.",
    benefits: [
      "Schnellere Bearbeitung von Service-, Vertriebs- und Backoffice-Postfächern",
      "Klare Priorisierung nach Thema, Dringlichkeit und Verantwortlichkeit",
      "Antwortentwürfe im gewünschten Tonfall statt unkontrollierter Vollautomatik",
      "Weniger Liegezeiten und sauber dokumentierte Übergaben",
    ],
    useCases: [
      {
        title: "Postfächer automatisch vorsortieren",
        description: "E-Mails klassifizieren, Zuständigkeiten erkennen und Tickets oder Aufgaben anlegen.",
      },
      {
        title: "Antwortentwürfe vorbereiten",
        description: "Standardisierte Rückmeldungen und Textbausteine kontextbezogen vorbereiten.",
      },
      {
        title: "Follow-ups und Fristen anstoßen",
        description: "Erinnerungen, Rückfragen und interne Eskalationen automatisch auslösen.",
      },
    ],
    implementation: [
      "Definition von Kategorien, Qualitätsregeln und Ausnahmen",
      "Anbindung an Postfächer, CRM, Ticketsysteme und Wissensquellen",
      "Review-Schleifen für sensible oder risikoreiche Kommunikation",
    ],
    ctaTitle: "Postfächer wieder beherrschbar machen",
    ctaText:
      "Wir identifizieren gemeinsam die E-Mail-Prozesse mit dem größten Hebel und bauen einen ersten belastbaren Automationspfad.",
    relatedPaths: [
      "/ki-agenten-fuer-unternehmen",
      "/ki-dokumentenverarbeitung",
      "/branchen/kanzlei",
    ],
  },
  {
    kind: "service",
    path: "/ki-dokumentenverarbeitung",
    title: "KI-Dokumentenverarbeitung für Unternehmen | ScandicDev",
    description:
      "KI-Dokumentenverarbeitung für Unternehmen: Dokumente lesen, Daten extrahieren, prüfen und in operative Workflows überführen.",
    h1: "KI-Dokumentenverarbeitung für Unternehmen",
    intro:
      "Wenn Informationen in PDFs, Scans, Formularen oder E-Mail-Anhängen feststecken, entstehen Medienbrüche und manuelle Nacharbeit. Wir automatisieren die Dokumentenverarbeitung so, dass Daten strukturiert erkannt, geprüft und in Ihre Systeme übergeben werden.",
    benefits: [
      "Weniger manuelle Datenerfassung und geringere Fehleranfälligkeit",
      "Schnellere Verarbeitung von Rechnungen, Formularen und Anlagen",
      "Klare Prüfpfade für unvollständige oder risikoreiche Dokumente",
      "Saubere Übergabe in ERP-, DMS- oder Fachsysteme",
    ],
    useCases: [
      {
        title: "Dokumente klassifizieren",
        description: "Dokumenttypen erkennen und direkt in die passende Bearbeitung leiten.",
      },
      {
        title: "Felder und Inhalte extrahieren",
        description: "Relevante Daten aus Rechnungen, Lieferscheinen, Formularen oder Schriftsätzen übernehmen.",
      },
      {
        title: "Folgeworkflows starten",
        description: "Freigaben, Rückfragen, Ablage oder Systemupdates automatisch anstoßen.",
      },
    ],
    implementation: [
      "Festlegung der zu extrahierenden Informationen und Qualitätsgrenzen",
      "Abbildung von Prüf- und Freigabeschritten für Sonderfälle",
      "Integration in DMS, ERP, Fachanwendungen und Reporting",
    ],
    ctaTitle: "Dokumente als strukturierten Prozess statt als Engpass behandeln",
    ctaText:
      "Wir prüfen, welche Dokumenttypen sich kurzfristig automatisieren lassen und wie Qualität und Nachvollziehbarkeit abgesichert werden.",
    relatedPaths: [
      "/ki-agenten-fuer-unternehmen",
      "/ki-email-automation",
      "/branchen/logistik",
    ],
  },
  {
    kind: "industry",
    path: "/branchen/logistik",
    title: "KI-Automatisierung für Logistikunternehmen | ScandicDev",
    description:
      "KI-Automatisierung für Logistikunternehmen: Telefon, E-Mail, Dokumente und operative Workflows in Transport, Disposition und Kundenservice entlasten.",
    h1: "KI-Automatisierung für Logistikunternehmen",
    intro:
      "In Logistikprozessen treffen hohe Taktung, viele Rückfragen und dokumentenlastige Abläufe auf knappe Dispositionszeit. Wir automatisieren genau die Schnittstellen, an denen Informationen verloren gehen oder Teams ausgebremst werden.",
    benefits: [
      "Schnellere Bearbeitung von Statusanfragen und Standardkommunikation",
      "Weniger manuelle Nacharbeit bei Lieferscheinen, Frachtpapieren und E-Mails",
      "Bessere Übergaben zwischen Disposition, Kundenservice und Backoffice",
      "Mehr operative Transparenz ohne zusätzliche Tool-Landschaften",
    ],
    useCases: [
      {
        title: "Status- und Serviceanfragen strukturieren",
        description: "Rückfragen vorsortieren, Informationen aus Systemen zusammenführen und standardisiert antworten.",
      },
      {
        title: "Transportdokumente verarbeiten",
        description: "Dokumente lesen, Daten übernehmen und Folgeprozesse anstoßen.",
      },
      {
        title: "Ausnahmen gezielt eskalieren",
        description: "Abweichungen und kritische Fälle früh markieren, statt sie im Tagesgeschäft zu verlieren.",
      },
    ],
    implementation: [
      "Auswahl der Prozesse mit hohem Volumen und klarer Wiederholbarkeit",
      "Integration in vorhandene TMS-, ERP- oder Service-Systeme",
      "Saubere Eskalationspfade für zeitkritische oder komplexe Fälle",
    ],
    ctaTitle: "Logistikprozesse mit weniger Reibung organisieren",
    ctaText:
      "Wir zeigen, welche operativen Abläufe sich in Logistik und Supply Chain sinnvoll mit KI stabilisieren lassen.",
    relatedPaths: [
      "/ki-dokumentenverarbeitung",
      "/ki-email-automation",
      "/ki-agenten-fuer-unternehmen",
    ],
  },
  {
    kind: "industry",
    path: "/branchen/kanzlei",
    title: "KI-Automatisierung für Kanzleien | ScandicDev",
    description:
      "KI-Automatisierung für Kanzleien: Mandantenkommunikation, Dokumente und interne Workflows strukturiert und DSGVO-konform entlasten.",
    h1: "KI-Automatisierung für Kanzleien",
    intro:
      "Kanzleien arbeiten mit hohem Dokumentenaufkommen, festen Fristen und sensibler Kommunikation. Wir automatisieren wiederkehrende Abläufe so, dass juristische Sorgfalt, Datenschutz und Nachvollziehbarkeit gewahrt bleiben.",
    benefits: [
      "Weniger manuelle Vorarbeit bei wiederkehrenden Mandantenanfragen",
      "Strukturierte Dokumentenaufnahme und Vorqualifizierung von Vorgängen",
      "Mehr Transparenz bei Zuständigkeiten, Fristen und Übergaben",
      "DSGVO-konforme Prozessautomatisierung mit klaren Kontrollpunkten",
    ],
    useCases: [
      {
        title: "Mandantenkommunikation vorstrukturieren",
        description: "Anliegen aufnehmen, Informationen sortieren und nächste Schritte vorbereiten.",
      },
      {
        title: "Dokumente und Eingänge prüfen",
        description: "Unterlagen klassifizieren und relevante Angaben für die Sachbearbeitung extrahieren.",
      },
      {
        title: "Interne Workflows anstoßen",
        description: "Aufgaben, Wiedervorlagen und Statusupdates regelbasiert anlegen.",
      },
    ],
    implementation: [
      "Abgrenzung zwischen vorbereitender Automatisierung und juristischer Bewertung",
      "Integration in DMS, Kanzleisoftware und Kommunikationskanäle",
      "Review- und Freigabeschritte für sensible Inhalte und Fristsachen",
    ],
    ctaTitle: "Kanzleiprozesse mit mehr Struktur und weniger Routineaufwand",
    ctaText:
      "Wir identifizieren gemeinsam, welche wiederkehrenden Abläufe entlastet werden können, ohne fachliche Verantwortung zu verwischen.",
    relatedPaths: [
      "/ki-email-automation",
      "/ki-dokumentenverarbeitung",
      "/ki-agenten-fuer-unternehmen",
    ],
  },
  {
    kind: "industry",
    path: "/branchen/arztpraxis",
    title: "KI-Automatisierung für Arztpraxen | ScandicDev",
    description:
      "KI-Automatisierung für Arztpraxen: Telefon, E-Mail und Dokumentenprozesse entlasten, damit Teams mehr Zeit für Patientinnen und Patienten haben.",
    h1: "KI-Automatisierung für Arztpraxen",
    intro:
      "Arztpraxen stehen unter hohem Kommunikationsdruck: Telefon, Terminanfragen, Rückfragen und Dokumente laufen parallel zum laufenden Betrieb. Wir helfen, wiederkehrende administrative Prozesse sauber zu strukturieren und zu entlasten.",
    benefits: [
      "Bessere Erreichbarkeit bei hohem Anruf- und Nachrichtenvolumen",
      "Entlastung des Teams bei Termin-, Rückruf- und Formularprozessen",
      "Klare Trennung zwischen administrativer Automatisierung und medizinischer Entscheidung",
      "Nachvollziehbare, DSGVO-konforme Abläufe für sensible Patientendaten",
    ],
    useCases: [
      {
        title: "Termin- und Rückrufanfragen strukturieren",
        description: "Anliegen aufnehmen, priorisieren und sauber an die Praxisorganisation übergeben.",
      },
      {
        title: "Administrative Patientenkommunikation entlasten",
        description: "Standardinformationen und organisatorische Rückmeldungen regelbasiert unterstützen.",
      },
      {
        title: "Formulare und Unterlagen vorbereiten",
        description: "Dokumente prüfen, Informationen extrahieren und Nachforderungen anstoßen.",
      },
    ],
    implementation: [
      "Abgrenzung zulässiger administrativer Use Cases",
      "Einbindung in Praxisabläufe, Kalender und Dokumentenprozesse",
      "Freigabe- und Eskalationsregeln für sensible oder unklare Fälle",
    ],
    ctaTitle: "Praxisorganisation entlasten, ohne medizinische Prozesse zu vermischen",
    ctaText:
      "Wir prüfen, welche administrativen Abläufe sich sinnvoll automatisieren lassen und wie Datenschutz und Verantwortlichkeiten abgesichert werden.",
    relatedPaths: [
      "/ki-telefonassistent",
      "/ki-dokumentenverarbeitung",
      "/ki-agenten-fuer-unternehmen",
    ],
  },
];

export const marketingPageMap = Object.fromEntries(
  marketingPages.map((page) => [page.path, page]),
);

export const mainServiceLinks = marketingPages.filter((page) => page.kind === "service");
export const industryLinks = marketingPages.filter((page) => page.kind === "industry");
